var api = require("!../../../.yarn/__virtual__/style-loader-virtual-96f5e81134/3/.yarn/berry/cache/style-loader-npm-1.3.0-2047b33843-10c0.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../.yarn/__virtual__/css-loader-virtual-11db3551b8/3/.yarn/berry/cache/css-loader-npm-3.6.0-3394f37d07-10c0.zip/node_modules/css-loader/dist/cjs.js!../../../.yarn/__virtual__/postcss-loader-virtual-69a5b50abb/3/.yarn/berry/cache/postcss-loader-npm-4.3.0-3e7af086e3-10c0.zip/node_modules/postcss-loader/dist/cjs.js!./style.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};